export default "__VITE_ASSET__8ac927bf__"